module.exports = __webpack_public_path__ + "img/987a112.png";